/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { addItemsToAlbumCollectionModelSchema } from "../addItemsToAlbumCollectionModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const postApiAlbumCollectionsIdAlbumsPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор выпуска")
    })

/**
 * @description Альбомы добавлены в выпуск
 */
export const postApiAlbumCollectionsIdAlbums200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const postApiAlbumCollectionsIdAlbums400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiAlbumCollectionsIdAlbums401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiAlbumCollectionsIdAlbums403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Выпуск не найден
 */
export const postApiAlbumCollectionsIdAlbums404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiAlbumCollectionsIdAlbums500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiAlbumCollectionsIdAlbumsMutationRequestSchema = z.lazy(() => addItemsToAlbumCollectionModelSchema).describe("Тело запроса")

export const postApiAlbumCollectionsIdAlbumsMutationResponseSchema = z.lazy(() => postApiAlbumCollectionsIdAlbums200Schema)